import { nextPage } from '../../store/page/actions';
import store from '../../store';

const CUSTOMER_EXPERIENCE = 'CustomerExperience';

export default function encerrarCoversaCliente(event){
    store.dispatch(nextPage(CUSTOMER_EXPERIENCE));

}